import pww from '../../images/projects/PWW.png';
import budgetApp from '../../images/projects/budgetApp.png';
import carApp from '../../images/projects/carApp.png';
import todolist from '../../images/projects/todolist.png';

export const projects = [
  {
    id: 1, status: 'Development', title: 'Math Magicians', img: pww, projectLink: 'https://github.com/Tobinchilongo/Math-Magicians', liveLink: 'https://mathmagician1.herokuapp.com/',
  },
  {
    id: 1, status: 'Development', title: 'MyBudget', img: budgetApp, projectLink: 'https://github.com/Tobinchilongo/Budget-App', liveLink: 'https://budget-app-zm.herokuapp.com/',
  },
  {
    id: 1, status: 'Development', title: 'Cinema Of Movies', img: carApp, projectLink: 'https://github.com/Tobinchilongo/JavaScript_Capstone', liveLink: 'https://elegant-selkie-bb0b20.netlify.app/',
  },
  {
    id: 1, status: 'Development', title: 'ToDoList', img: todolist, projectLink: 'https://github.com/Tobinchilongo/To-Do-List', liveLink: 'https://determined-yonath-3d7953.netlify.app/',
  },
];

export default 'Project Data';
